import { useQuery } from '@tanstack/react-query';

import { lookupCodesQueryOptions } from '../../data-provider/lookup-codes';

export const LookupCodeType = {
  Accessorials: 'FBACCCHG',
  CargoType: 'CARGO',
  Class: 'CLASS',
  DirectInterline: 'DRCTIRLN',
  PricingType: 'PRITYPE',
  ShipTerm: 'SHIPTERM',
  ShipType: 'SHIPTYPE',
  TariffType: 'BASIS',
  TransportType: 'LINERTYP',
  Units: 'UNITS',
} as const;

// Base hook
export const useGetLookupCodes = (lookupCodeType: string, enabled?: boolean, keys?: number[]) => {
  return useQuery(lookupCodesQueryOptions(lookupCodeType, keys, enabled));
};

// Specialized hooks
export const useGetShipTypes = () => useGetLookupCodes(LookupCodeType.ShipType);
export const useGetDirectInterline = () => useGetLookupCodes(LookupCodeType.DirectInterline);
export const useGetPricingTypes = () => useGetLookupCodes(LookupCodeType.PricingType);
export const useGetAccessorialsLookups = ({ enabled, keys }: { enabled: boolean; keys?: number[] }) =>
  useGetLookupCodes(LookupCodeType.Accessorials, enabled, keys);
export const useGetShipTerms = () => useGetLookupCodes(LookupCodeType.ShipTerm);
export const useGetClasses = () => useGetLookupCodes(LookupCodeType.Class);
export const useGetUnits = () => useGetLookupCodes(LookupCodeType.Units);
